export default "__VITE_ASSET__qYKWUEoN__"